
;(function () {
	const brandImage = (section) => {

    const marquee = section.querySelector('.marquee');
		const track = marquee.querySelector('.track');

		function setupMarquee() {
			// reset (important on resize)
			track.innerHTML = track.dataset.original || track.innerHTML;
			track.dataset.original = track.innerHTML;

			const containerWidth = marquee.offsetWidth;
			let contentWidth = track.scrollWidth;

			// clone until content is at least 2x container width
			while (contentWidth < containerWidth * 2) {
				track.innerHTML += track.dataset.original;
				contentWidth = track.scrollWidth;
			}

			// set CSS variable for smooth animation distance
			track.style.setProperty('--scroll-width', contentWidth / 2 + 'px');

			// speed control (pixels per second feel)
			const speed = 200; // lower = slower
			const duration = contentWidth / speed;

			track.style.animationDuration = `${duration}s`;
		}

    setupMarquee();
		window.addEventListener('resize', setupMarquee);

		let isDown = false;
		let startX;
		let currentTranslate = 0;

		/*
			marquee.addEventListener('mousedown', (e) => {
				isDown = true;
				track.style.animationPlayState = 'paused';
				startX = e.pageX;
			}); 
		*/
		marquee.addEventListener('mouseenter', (e) => {
			isDown = true;
			track.style.animationPlayState = 'paused';
			startX = e.pageX;
		});
		/*
		  window.addEventListener('mouseup', () => {
				isDown = false;
				track.style.animationPlayState = 'running';
			}); 

			window.addEventListener('mousemove', (e) => {
				if (!isDown) return;

				const walk = e.pageX - startX;
				track.style.transform = `translateX(${currentTranslate + walk}px)`;			
			});
		*/

		marquee.addEventListener('mouseleave', () => {
			isDown = false;
			track.style.animationPlayState = 'running';			
		});

  }
	
  const currentScript = document.currentScript;
	document.addEventListener('DOMContentLoaded', function () {
		brandImage(currentScript.parentElement)
		document.addEventListener('shopify:section:load', function () {
			brandImage(section.target)
		})
		// window.addEventListener('resize', function () {
		// 	cardList()
		// })
	})
})()